/**
 * This page will display the event associated to the ID in the page's route.
 */

import { GetStaticPaths, GetStaticProps } from "next";
import EventPage, {
  getEventStaticPaths,
  getEventStaticProps,
} from "@dreambigger/inspire-events/src/components/views/detail";

// Get the static paths for the event that we want to prerender.
export const getStaticPaths: GetStaticPaths = getEventStaticPaths;

// Get data to statically generate the actual event.
export const getStaticProps: GetStaticProps = getEventStaticProps;

export default EventPage;
